export enum TabsConsumptionDetailsEnum {
    GENERAL = "GENERAL" ,
    DATA = "DATA",
    CALL = "CALL",
    SMS = "SMS"
}
